import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import WaitlistApiService from '../../../api/WaitlistApiService';
import { DefaultFacilityId } from '../../../utilities/Constants';
import AppDialog from '../AppDialog';

export default function JoinWaitlistModal(props) {
    const { open, close, setSnackbarProperties, onJoined } = props;

    const [sizes, setSizes] = useState([]);
    const [selectedSize, setSelectedSize] = useState('');
    const [loading, setLoading] = useState(false);

    const waitlistApiService = new WaitlistApiService();

    useEffect(() => {
        if (!open) return;
        let cancelled = false;
        async function loadSizes() {
            setLoading(true);
            const response = await waitlistApiService.getAvailableSizes(DefaultFacilityId);
            if (cancelled) return;
            if (response?.success) {
                setSizes(response.data || []);
            } else {
                setSnackbarProperties('Unable to load storage sizes', 'error');
            }
            setLoading(false);
        }
        loadSizes();
        return () => { cancelled = true; };
    }, [open]);

    async function handleJoin() {
        if (!selectedSize) {
            setSnackbarProperties('Please choose a size', 'warning');
            return;
        }
        setLoading(true);
        const response = await waitlistApiService.join(DefaultFacilityId, selectedSize);
        setLoading(false);

        if (response?.success) {
            setSnackbarProperties('You\'re on the list! We\'ll email you when a unit is available.', 'success');
            setSelectedSize('');
            if (onJoined) onJoined();
            close();
        } else {
            setSnackbarProperties(response?.message || 'Unable to join waitlist', 'error');
        }
    }

    function handleClose() {
        setSelectedSize('');
        close();
    }

    return (
        <AppDialog
            open={open}
            onClose={handleClose}
            title='Join the Waitlist'
            onSubmit={handleJoin}
            submitText='Join Waitlist'
            submitDisabled={!selectedSize}
            busy={loading}
        >
            <Typography variant='body1' sx={{ mb: 2 }}>
                Don&apos;t see the size you need? Join the waitlist and we&apos;ll email you
                as soon as a unit of your chosen size becomes available.
            </Typography>
            <FormControl fullWidth>
                <InputLabel id='waitlist-size-label'>Storage Size</InputLabel>
                <Select
                    labelId='waitlist-size-label'
                    label='Storage Size'
                    value={selectedSize}
                    onChange={(event) => setSelectedSize(event.target.value)}
                    disabled={loading || sizes.length === 0}
                >
                    {sizes.map((size) => (
                        <MenuItem key={size} value={size}>{size}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </AppDialog>
    );
}

JoinWaitlistModal.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    setSnackbarProperties: PropTypes.func.isRequired,
    onJoined: PropTypes.func,
};